// assets/custom-components-pills.js
(() => {
  const SELECTORS = {
    pillsWrap: "[data-components-pills]",
    pillDetails: "details[data-component-pill]",
    closeBtn: "[data-component-close]"
  };

  // Закрити всі details, крім одного (в межах одного wrapper)
  function closeOthers(wrapper, exceptDetails) {
    wrapper.querySelectorAll(SELECTORS.pillDetails).forEach((d) => {
      if (d !== exceptDetails) d.removeAttribute("open");
    });
  }

  // 1) Only-one-open: ловимо toggle у фазі capture (бо toggle не bubbling)
  document.addEventListener(
    "toggle",
    (e) => {
      const details = e.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.matches(SELECTORS.pillDetails)) return;

      const wrapper = details.closest(SELECTORS.pillsWrap);
      if (!wrapper) return;

      if (details.open) closeOthers(wrapper, details);
    },
    true
  );

  // 2) Закриття по ✕ (delegation)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(SELECTORS.closeBtn);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const details = btn.closest("details");
    if (details) details.removeAttribute("open");
  });
})();
